import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';
import {Icon} from 'front-onceforall-core';
import {notificationType} from '../../../../utils/constant';

function ActionsView(props) {
  const cannotAddUser = props.invitation.type === notificationType.USER_PENDING && !props.canAddUser;

  const actionsTrad = props.isSuggestion ? 'invitation.suggestion.actions' : 'invitation.received.actions';

  const invitingOrganisationName = props.invitation?.relationship?.invitingOrganisationName || props.invitation.invitingOrganisationName;

  return (
    <>
      <Tooltip
        title={<Translate
          invitingOrganisationName={invitingOrganisationName}
          value={cannotAddUser ? 'user.maxUsersReached' : `${actionsTrad}.accept`}
        />}
        placement="top"
      >
        <span>
          <button
            className="button-square success"
            onClick={() => props.onAccept(props.invitation)}
            disabled={cannotAddUser}
            style={cannotAddUser ? {pointerEvents: 'none'} : {}}
          >
            <Icon icon="check"/>
          </button>
        </span>
      </Tooltip>
      <Tooltip
        title={<Translate
          invitingOrganisationName={invitingOrganisationName}
          value={`${actionsTrad}.reject`}
        />}
        placement="top"
      >
        <span>
          <button
            className="button-square error"
            onClick={() => props.onReject(props.invitation)}
          >
            <Icon icon="cross"/>
          </button>
        </span>
      </Tooltip>
    </>
  );
}

ActionsView.defaultProps = {
  isSuggestion: false
};

ActionsView.propTypes = {
  invitation: PropTypes.object.isRequired,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  canAddUser: PropTypes.bool,
  isSuggestion: PropTypes.bool
};

export default ActionsView;
